import { getProductLink } from 'swag-client-common/utils/tricks';

/**
 *
 * @param props
 * @return {
 *    {
 *      isImageLoading: boolean,
 *      activeShadeIndex: number,
 *      isShadesVisible: boolean,
 *      logo: string,
 *      link: string,
 *      isSetColorFilter: boolean,
 *      color: string
 *    }
 *  }
 */
export function getInitialState(props) {
  const {
    item: {
      colorFilterThumbnails,
      logoThumbnail,
      logoBranded,
      seoSlug
    }
  } = props;
  const isSetColorFilter = getIsSetColorFilter(props);
  let logo = logoBranded ? logoBranded : logoThumbnail;
  let link = getProductLink(seoSlug);
  let activeShadeIndex = null;
  const isShadesVisible = false;
  let color = '';
  if (isSetColorFilter) {
    activeShadeIndex = 0;
    const activeShade = colorFilterThumbnails[activeShadeIndex];
    logo = activeShade.thumbnail;
    color = activeShade.color;
    link = getProductLink(seoSlug);
  }
  return {
    isImageLoading: true,
    activeShadeIndex,
    isShadesVisible,
    logo,
    link,
    isSetColorFilter,
    color
  };
}

/**
 *
 * @param props
 * @return {boolean}
 */
function getIsSetColorFilter(props) {
  return props.appliedFilter && props.appliedFilter.colorFamily && props.appliedFilter.colorFamily.length > 0 && props.item.colorFilterThumbnails && props.item.colorFilterThumbnails.length > 0;
}